import { Form } from 'antd';
import { E164Number } from 'libphonenumber-js/types';
import React, { FunctionComponent, useEffect, useState } from 'react';
import PhoneInputWithCountrySelect, { Country, isValidPhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';
import { useAppStore } from '../../../store/Store';
import { ScreenWrapper } from '../../styles/Containers';
import { Spacer } from '../../styles/Dividers';
import { NextButton, SecondaryButton } from '../../styles/LayoutButtons';
import { BodySM, ErrorBody, Heading3 } from '../../styles/Typography';

export type PhoneNumberLayoutConfig = {
  title: string;
  topBody: string[];
  bottomBody: string[];
  primaryButtonTitle: string;
  required?: boolean;
  hideSkipButton?: boolean;
  skipButtonTitle?: string;
};

type PhoneNumberLayoutProps = PhoneNumberLayoutConfig & {
  onSubmit: (phoneNumber: string | undefined) => void;
};

export const PhoneNumberLayout: FunctionComponent<PhoneNumberLayoutProps> = (props) => {
  const { required = false, hideSkipButton = true, skipButtonTitle = 'Skip' } = props;

  const country = useAppStore((state) => state.geolocation.country);
  const [phoneNumber, setPhoneNumber] = useState<E164Number>();
  const [isValid, setIsValid] = useState(!required);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);

  useEffect(
    function isValidNumber() {
      if (phoneNumber !== undefined) {
        setIsValid(isValidPhoneNumber(phoneNumber.toString()));
      } else {
        setIsValid(!required);
      }
    },
    [phoneNumber]
  );

  function handleSubmit() {
    setHasAttemptedSubmit(true);
    if (isValid) {
      props.onSubmit(phoneNumber?.toString());
    }
  }

  return (
    <ScreenWrapper>
      <Heading3 style={{ textAlign: 'left' }}>{props.title}</Heading3>

      <Copy copy={props.topBody} />

      <Form onFinish={handleSubmit}>
        <Form.Item>
          <PhoneInputWithCountrySelect
            value={phoneNumber}
            onChange={setPhoneNumber}
            defaultCountry={country as Country}
            international
            countryCallingCodeEditable={false}
            numberInputProps={{ style: { height: '40px' } }}
            flags={flags}
          />
          {!isValid && hasAttemptedSubmit && <ErrorBody>Mobile number is not valid</ErrorBody>}
        </Form.Item>

        <Copy copy={props.bottomBody} />

        <Form.Item>
          <Spacer space={64} mobile={24} />
          <NextButton>{props.primaryButtonTitle}</NextButton>
          {required && !hideSkipButton && (
            <SecondaryButton onClick={() => props.onSubmit(undefined)}>
              {skipButtonTitle}
            </SecondaryButton>
          )}
        </Form.Item>
      </Form>
    </ScreenWrapper>
  );
};

type CopyProps = { copy: string[] };
const Copy: FunctionComponent<CopyProps> = (props) => (
  <>
    {props.copy.map((text, i) => (
      <BodySM style={{ textAlign: 'left' }} key={i}>
        {text}
      </BodySM>
    ))}
  </>
);
